import React from 'react';
import { Global, css } from '@emotion/core';
// import 'typeface-montserrat';
import 'typeface-roboto';

const styles = css`
  html {
    margin: 0;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: 1fr;
  }
  body {
    min-height: 100%;
    margin: 0;
    display: grid;
    grid-template-rows: 1fr;
    font-family: 'Latitude Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
      'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #root {
    display: grid;
    grid-template-rows: auto 1fr auto;
  }

  @font-face {
    font-family: 'Latitude Sans';
    font-weight: 400;
    font-style: normal;
    src: url('/latitude-sans/LatitudeSans-Regular.woff2') format('woff2'),
      url('/latitude-sans/LatitudeSans-Regular.woff') format('woff');
  }

  @font-face {
    font-family: 'Latitude Sans';
    font-weight: 400;
    font-style: italic;
    src: url('/latitude-sans/LatitudeSans-Italic.woff2') format('woff2'),
      url('/latitude-sans/LatitudeSans-Italic.woff') format('woff');
  }

  @font-face {
    font-family: 'Latitude Sans';
    font-weight: 500;
    font-style: normal;
    src: url('/latitude-sans/LatitudeSans-Medium.woff2') format('woff2'),
      url('/latitude-sans/LatitudeSans-Medium.woff') format('woff');
  }

  @font-face {
    font-family: 'Latitude Sans';
    font-weight: 500;
    font-style: italic;
    src: url('/latitude-sans/LatitudeSans-MediumItalic.woff2') format('woff2'),
      url('/latitude-sans/LatitudeSans-MediumItalic.woff') format('woff');
  }

  @font-face {
    font-family: 'Latitude Sans';
    font-weight: 600;
    font-style: normal;
    src: url('/latitude-sans/LatitudeSans-SemiBold.woff2') format('woff2'),
      url('/latitude-sans/LatitudeSans-SemiBold.woff') format('woff');
  }

  @font-face {
    font-family: 'Latitude Sans';
    font-weight: 600;
    font-style: italic;
    src: url('/latitude-sans/LatitudeSans-SemiBoldItalic.woff2') format('woff2'),
      url('/latitude-sans/LatitudeSans-SemiBoldItalic.woff') format('woff');
  }

  @font-face {
    font-family: 'Latitude Sans';
    font-weight: 700;
    font-style: normal;
    src: url('/latitude-sans/LatitudeSans-Bold.woff2') format('woff2'),
      url('/latitude-sans/LatitudeSans-Bold.woff') format('woff');
  }

  @font-face {
    font-family: 'Latitude Sans';
    font-weight: 700;
    font-style: italic;
    src: url('/latitude-sans/LatitudeSans-BoldItalic.woff2') format('woff2'),
      url('/latitude-sans/LatitudeSans-BoldItalic.woff') format('woff');
  }

  main {
    display: grid;
    grid-template-rows: 1fr;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }
`;

export const GlobalStyle = () => <Global styles={styles} />;
